import React from 'react'
import './CustomVideoControls.css'

const CustomVideoControls = ({
  isPlaying,
  isMuted,
  volume,
  currentTime,
  duration,
  isFullscreen,
  streamName,
  description,
  onPlayPause,
  onMuteToggle,
  onVolumeChange,
  onSeek,
  onFullscreenToggle,
  onAirplayToggle,
  onBack,
  onTitleHoverChange
}) => {
  const [isTitleExpanded, setIsTitleExpanded] = React.useState(false)

  // Curăță HTML-ul și pune totul pe un singur rând cu separator " • "
  const sanitizeDescription = (html) => {
    if (!html) return ''
    return html
      // Elimină toate tag-urile HTML păstrând doar textul
      .replace(/<[^>]*>/g, ' ')
      // Înlocuiește newlines cu spații
      .replace(/\n/g, ' ')
      .replace(/\r/g, ' ')
      // Comprimă spațiile multiple
      .replace(/\s+/g, ' ')
      .trim()
  }

  // Calculează durata animației bazată pe lungimea textului
  // ~78 pixeli per secundă (30% mai rapid decât 60)
  const calculateAnimationDuration = (text) => {
    if (!text) return 35
    const cleanText = text.replace(/<[^>]*>/g, '') // Remove HTML tags
    const charCount = cleanText.length
    const estimatedWidth = charCount * 11 // ~11px per character at 18px font
    const pixelsPerSecond = 78 // 30% faster than 60
    const duration = estimatedWidth / pixelsPerSecond
    return Math.max(20, duration) // Minimum 20s
  }

  const handleTitleMouseEnter = () => {
    if (description) {
      setIsTitleExpanded(true)
      if (onTitleHoverChange) {
        onTitleHoverChange(true)
      }
    }
  }

  const handleTitleMouseLeave = () => {
    setIsTitleExpanded(false)
    if (onTitleHoverChange) {
      onTitleHoverChange(false)
    }
  }
  const formatTime = (seconds) => {
    if (!Number.isFinite(seconds) || seconds < 0) return '00:00'
    const mins = Math.floor(seconds / 60)
    const secs = Math.floor(seconds % 60)
    return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
  }

  const handleSeekChange = (e) => {
    const newTime = parseFloat(e.target.value)
    onSeek(newTime)
  }

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value)
    onVolumeChange(newVolume)
  }

  const getVolumeIcon = () => {
    if (isMuted || volume === 0) {
      return (
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.2872 10.0556C22.49 10.9598 23.4156 12.1841 23.9588 13.5893C24.502 14.9945 24.6412 16.5243 24.3603 18.0048M22.1471 22.1969C21.8785 22.4661 21.5911 22.7159 21.2872 22.9444M25.6268 5.22222C28.2064 7.3119 29.9913 10.2267 30.6824 13.4783C31.3736 16.7299 30.929 20.1208 29.4232 23.083M26.7294 26.7869C26.379 27.1359 26.011 27.4666 25.6268 27.7778M11.7545 5.30918L12.4472 4.41662C12.5877 4.14311 12.8212 3.92898 13.1054 3.81293C13.3896 3.69688 13.7059 3.68656 13.9971 3.78385C14.2882 3.88113 14.535 4.0796 14.693 4.34338C14.8509 4.60717 14.9095 4.91887 14.8581 5.22218V8.4444M14.8581 14.8888V27.7777C14.9095 28.081 14.8509 28.3927 14.693 28.6565C14.535 28.9203 14.2882 29.1188 13.9971 29.2161C13.7059 29.3134 13.3896 29.303 13.1054 29.187C12.8212 29.0709 12.5877 28.8568 12.4472 28.5833L6.8218 21.3333H3.60727C3.18099 21.3333 2.77218 21.1635 2.47076 20.8614C2.16934 20.5593 2 20.1495 2 19.7222V13.2777C2 12.8504 2.16934 12.4406 2.47076 12.1385C2.77218 11.8364 3.18099 11.6666 3.60727 11.6666H6.8218L8.90161 8.98573M2 2L30.9308 31" stroke="black" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    } else if (volume < 0.5) {
      return (
        <svg width="30" height="33" viewBox="0 0 30 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M24.2857 9.18957C25.439 10.0408 26.375 11.1445 27.0197 12.4134C27.6644 13.6822 28 15.0814 28 16.5C28 17.9187 27.6644 19.3179 27.0197 20.5867C26.375 21.8556 25.439 22.9593 24.2857 23.8105M7.57143 21.9829H3.85714C3.3646 21.9829 2.89223 21.7903 2.54394 21.4476C2.19566 21.1048 2 20.64 2 20.1552V12.8448C2 12.36 2.19566 11.8952 2.54394 11.5524C2.89223 11.2097 3.3646 11.0171 3.85714 11.0171H7.57143L14.0714 2.79284C14.2337 2.48257 14.5035 2.23966 14.8319 2.10802C15.1603 1.97637 15.5258 1.96467 15.8622 2.07503C16.1986 2.18539 16.4838 2.41052 16.6663 2.70976C16.8488 3.00899 16.9165 3.36259 16.8571 3.70665V29.2933C16.9165 29.6374 16.8488 29.991 16.6663 30.2902C16.4838 30.5895 16.1986 30.8146 15.8622 30.925C15.5258 31.0353 15.1603 31.0236 14.8319 30.892C14.5035 30.7603 14.2337 30.5174 14.0714 30.2072L7.57143 21.9829Z" stroke="black" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    } else {
      return (
        <svg width="36" height="32" viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M23.2823 8.94165C24.3836 9.76349 25.2775 10.8292 25.8932 12.0543C26.5088 13.2794 26.8294 14.6303 26.8294 16C26.8294 17.3698 26.5088 18.7207 25.8932 19.9458C25.2775 21.1709 24.3836 22.2366 23.2823 23.0584M28.0708 3.64785C29.9223 5.13656 31.4157 7.01846 32.4416 9.15573C33.4675 11.293 34 13.6315 34 16C34 18.3686 33.4675 20.7071 32.4416 22.8444C31.4157 24.9816 29.9223 26.8635 28.0708 28.3522M7.32058 21.2938H3.77353C3.30316 21.2938 2.85205 21.1079 2.51945 20.777C2.18685 20.446 2 19.9972 2 19.5292V12.4708C2 12.0028 2.18685 11.554 2.51945 11.223C2.85205 10.8921 3.30316 10.7062 3.77353 10.7062H7.32058L13.5279 2.7655C13.6829 2.46593 13.9405 2.2314 14.2542 2.10429C14.5678 1.97719 14.9168 1.96589 15.238 2.07244C15.5593 2.179 15.8317 2.39637 16.0059 2.68528C16.1802 2.9742 16.2448 3.3156 16.1882 3.6478V28.3522C16.2448 28.6844 16.1802 29.0258 16.0059 29.3147C15.8317 29.6036 15.5593 29.821 15.238 29.9276C14.9168 30.0341 14.5678 30.0228 14.2542 29.8957C13.9405 29.7686 13.6829 29.5341 13.5279 29.2345L7.32058 21.2938Z" stroke="black" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    }
  }

  return (
    <div className="custom-video-controls">
      {/* Top Controls */}
      <div className="controls-top">
        {/* Back Button */}
        <button className="control-pill control-back" onClick={onBack} aria-label="Back">
          <svg width="41" height="34" viewBox="0 0 41 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.3333 21.6667L3 12.3333M3 12.3333L12.3333 3M3 12.3333H28.6667C31.142 12.3333 33.516 13.3167 35.2663 15.067C37.0167 16.8173 38 19.1913 38 21.6667C38 24.142 37.0167 26.516 35.2663 28.2663C33.516 30.0167 31.142 31 28.6667 31H26.3333" stroke="black" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {/* Top Right Controls */}
        <div className="control-pill control-actions">
          <button onClick={onAirplayToggle} aria-label="Airplay">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 29.6667H3.01666M9.66556 29.6667C9.66556 27.8986 8.96329 26.2029 7.71326 24.9526C6.46323 23.7024 4.76782 23 3 23M16.3311 29.6667C16.3311 26.1304 14.9266 22.7391 12.4265 20.2386C9.92645 17.7381 6.53563 16.3333 3 16.3333M22.9967 29.6666H27.9958C28.4899 29.6668 28.9813 29.5938 29.4539 29.4499M32.7867 26.1166C32.9283 25.6474 33.0002 25.16 33 24.6699V11.3366C33 10.0105 32.4733 8.73874 31.5358 7.80105C30.5983 6.86337 29.3267 6.33659 28.0008 6.33659H13.0033M6.56274 6.56326C5.82082 6.79476 5.14308 7.19609 4.58335 7.73538C4.02362 8.27466 3.59731 8.93704 3.33828 9.66992M3 3L32.995 33" stroke="black" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button onClick={onFullscreenToggle} aria-label="Fullscreen">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 10.5V6.75C3 5.75544 3.39509 4.80161 4.09835 4.09835C4.80161 3.39509 5.75544 3 6.75 3H10.5M3 25.5V29.25C3 30.2446 3.39509 31.1984 4.09835 31.9016C4.80161 32.6049 5.75544 33 6.75 33H10.5M25.5 3H29.25C30.2446 3 31.1984 3.39509 31.9016 4.09835C32.6049 4.80161 33 5.75544 33 6.75V10.5M25.5 33H29.25C30.2446 33 31.1984 32.6049 31.9016 31.9016C32.6049 31.1984 33 30.2446 33 29.25V25.5" stroke="black" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

      {/* Title - Completely separate from top controls */}
      <div 
        className={`control-pill control-title ${isTitleExpanded ? 'control-title--expanded' : ''}`}
        onMouseEnter={handleTitleMouseEnter}
        onMouseLeave={handleTitleMouseLeave}
      >
        <div className="control-title-content">
          <span className="control-title-text">{streamName}</span>
          {description && isTitleExpanded && (
            <div className="control-title-description-wrapper">
              <span 
                className="control-title-description"
                style={{ animationDuration: `${calculateAnimationDuration(description)}s` }}
                dangerouslySetInnerHTML={{ __html: sanitizeDescription(description) }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Bottom Controls */}
      <div className="controls-bottom">
        {/* Left: Play/Pause and Volume */}
        <div className="control-pill control-playback">
          <button className="play-pause-btn" onClick={onPlayPause} aria-label={isPlaying ? 'Pause' : 'Play'}>
            {isPlaying ? (
              <svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.14286 0H3.57143C2.62423 0 1.71582 0.368749 1.04605 1.02513C0.376274 1.6815 0 2.57174 0 3.5V24.5C0 25.4283 0.376274 26.3185 1.04605 26.9749C1.71582 27.6313 2.62423 28 3.57143 28H7.14286C8.09006 28 8.99846 27.6313 9.66824 26.9749C10.338 26.3185 10.7143 25.4283 10.7143 24.5V3.5C10.7143 2.57174 10.338 1.6815 9.66824 1.02513C8.99846 0.368749 8.09006 0 7.14286 0Z" fill="black"/>
                <path d="M21.4286 0H17.8571C16.9099 0 16.0015 0.368749 15.3318 1.02513C14.662 1.6815 14.2857 2.57174 14.2857 3.5V24.5C14.2857 25.4283 14.662 26.3185 15.3318 26.9749C16.0015 27.6313 16.9099 28 17.8571 28H21.4286C22.3758 28 23.2842 27.6313 23.954 26.9749C24.6237 26.3185 25 25.4283 25 24.5V3.5C25 2.57174 24.6237 1.6815 23.954 1.02513C23.2842 0.368749 22.3758 0 21.4286 0Z" fill="black"/>
              </svg>
            ) : (
              <svg width="28" height="34" viewBox="0 0 28 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 3V31L25 17L3 3Z" stroke="black" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </button>

          <button className="volume-btn" onClick={onMuteToggle} aria-label={isMuted ? 'Unmute' : 'Mute'}>
            {getVolumeIcon()}
          </button>

          <div className="volume-slider-container">
            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={isMuted ? 0 : volume}
              onChange={handleVolumeChange}
              className="volume-slider"
              aria-label="Volume"
            />
            <div className="volume-track" />
            <div 
              className="volume-fill" 
              style={{ width: `${(isMuted ? 0 : volume) * 100}%` }} 
            />
            <div 
              className="volume-thumb" 
              style={{ left: `${(isMuted ? 0 : volume) * 100}%` }} 
            />
          </div>
        </div>

        {/* Right: Live Indicator and Seek */}
        <div className="control-pill control-seek">
          <div className="live-indicator">
            <span className="live-dot"></span>
            <span className="live-text">LIVE</span>
          </div>

          <span className="time-display">{formatTime(currentTime)}</span>

          <div className="seek-slider-container">
            <input
              type="range"
              min="0"
              max={duration || 0}
              step="0.1"
              value={currentTime}
              onChange={handleSeekChange}
              className="seek-slider"
              aria-label="Seek"
            />
            <div className="seek-track" />
            <div 
              className="seek-fill" 
              style={{ width: `${duration ? (currentTime / duration) * 100 : 0}%` }} 
            />
            <div 
              className="seek-thumb" 
              style={{ left: `${duration ? (currentTime / duration) * 100 : 0}%` }} 
            />
          </div>

          <span className="time-display">{formatTime(duration - currentTime)}</span>
        </div>
      </div>
    </div>
  )
}

export default CustomVideoControls

